export const PATHS = {
    INDEX: "/",
    GAME_PAGE_BASE: "/s-game-page",
    get GAME_PAGE() {
        return `${this.GAME_PAGE_BASE}/:gameName`
    },
    GAME_CATEGORY: "/s-game/category/:categoryId",
    SECTIONS: "/s-game/sections/:sectionId",
    // 個人中心
    MY: "/my",
    VIP: "/s-vip",
    VIP_LEVEL_SYSTEM: "/s-vip/level-system",

    // 帳號
    ACCOUNT: "/s-account",

    // 交易紀錄
    TRANSACTION: "/s-transaction",

    // 交易狀態
    TRANSACTION_STATUS: "/s-transaction/status",

    // 投注紀錄
    BET_RECORD: "/bet-record",

    // 投注紀錄詳細
    BET_RECORD_DETAIL: "/bet-record/:id",

    // Code登入
    LOGIN: "/login",

    // Password登入
    LOGIN_PASSWORD: "/loginPassword",

    //忘记密码
    FORGET_PASSWORD: "/forgetPassword",

    // 範例
    EXAMPLE: "/example",

    // 活动
    WELFARE: "/welfare",

    // 盲盒
    BLIND_BOX: "/blind-box",

    // PP
    DAILY_WINS: "/daily-wins",

    // Points
    POINTS: "/s-points",

    // Invite
    INVITE: "/invite",

    WITHDRAW_ACCOUNTS: "/withdraw-accounts",

    // 條款
    TERMS_OF_USE: "/terms-of-use",

    // 隱私政策
    PRIVACY_POLICY: "/privacy-policy",

    // KYC
    KYC: "/s-kyc",

    // GLife 跳轉
    GLIFE_REDIRECT_GLIFE_MINI_PROGRAM: "/Glife",
    GLIFE_REDIRECT_GCASH_REDIRECT_WEBSITE: "/GGames",
    GLIFE_REDIRECT_USER: "/glifeuser",

    //Lazadamini 跳转
    LAZADAMINI_REDIRECT: "/lazadamini",
    LAZADAMINI_REDIRECT_USER: "/lazadaminiuser",

    //Mayamoni 跳转
    MAYAMINI_REDIRECT: "/mayamini",
    MAYAMINI_REDIRECT_USER: "/mayaminiuser",

    // Docs
    DOCS: "/s-docs",

    //Download
    DOWNLOAD: "/s-download",
}
